<div id="app-home">
  <!-- Audio Permission Prompt -->
  <div *ngIf="showAudioPermissionPrompt" class="audio-permission-overlay">
    <div class="audio-permission-card">
      <div class="audio-permission-icon">
        <mat-icon>volume_up</mat-icon>
      </div>
      <h2>Enable Notification Sounds?</h2>
      <p>
        To hear notification sounds, please tap "Enable Sounds" below. This is
        required by your browser's security policy.
      </p>
      <div class="audio-permission-buttons">
        <button class="enable-button" (click)="enableNotificationSounds()">
          <mat-icon>volume_up</mat-icon>
          Enable Sounds
        </button>
        <button class="dismiss-button" (click)="dismissAudioPrompt()">
          Maybe Later
        </button>
      </div>
    </div>
  </div>

  <!-- Actual Content -->
  <div id="app-home-inner-content">
    <div id="offline-watermark" *ngIf="!online">
      <mat-icon>signal_cellular_connected_no_internet_4_bar</mat-icon>
      <span>Offline Or Slow Internet Speeds.</span>
      <span>Some features may not be available.</span>
    </div>
    <div id="desktop-home-header-container" *ngIf="isDesktop">
      <div id="desktop-home-header" *ngIf="isDesktop">
        <div id="header-mask"></div>
        <div id="header-name-and-org">
          <span>Welcome {{ firstName }}</span>
        </div>
        <div id="header-spacer"></div>
        <div id="header-badge">
          <img
            id="home-logo-img-desktop"
            [src]="organizationLogoUrl | safeUrl"
            alt="Logo"
          />
        </div>
      </div>
    </div>
    <div id="home-body">
      <!-- Skeleton Loader -->
      <div *ngIf="isLoading || !hasFeatureOrder" class="skeleton-loader">
        <div class="loading-message">
          <mat-icon class="loading-icon">cloud_download</mat-icon>
          <span>Loading features...</span>
        </div>
        <div class="skeleton-content">
          <div
            class="skeleton-feature"
            *ngFor="let _ of [1, 2, 3, 4, 5, 6, 7, 8]"
          ></div>
        </div>
      </div>
      <div
        id="feature-scrollable-container"
        *ngIf="!isLoading && hasFeatureOrder"
      >
        <div id="feature-container">
          <div
            *ngFor="let feature of filterFeaturesForScreenSize()"
            class="feature-tile"
            [class.feature-tile-offline-unsupported]="
              feature.offlineUnsupported
            "
            (click)="navigateToFeature(feature)"
            clickable
          >
            <div class="item-wrapper">
              <div class="item-icon-container">
                <img
                  [src]="getIcon(feature) | safeUrl"
                  [alt]="feature.homeName"
                  (error)="onImageError()"
                />
                <div
                  class="offline-unsupported-badge"
                  *ngIf="feature.offlineUnsupported"
                  title="May not work while offline"
                >
                  <mat-icon>cloud_off</mat-icon>
                </div>
              </div>
              <p class="item-text">{{ feature.homeName }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
